import Vue from "vue";
import VueRouter from "vue-router";
import permissions from "@/domain/permissions";
import trans from "@/utils/translation";
import PageForbidden from "@/views/PageForbidden";
import PageNotFound from "@/views/PageNotFound";

Vue.use(VueRouter);

function load(component) {
  return () =>
    import(/* webpackChunkName: "[request]" */ `@/views/${component}`);
}

const routes = [
  {
    path: "/:lang?/profile",
    component: load("Profile"),
    children: [
      {
        path: "",
        name: "basicProfile",
        component: load("BasicProfile"),
      },
      {
        path: "teacher",
        name: "teacherProfile",
        component: load("TeacherProfile"),
        meta: { requiredPermission: permissions.TEACHER_PROFILE },
      },
      {
        path: "parent",
        name: "parentProfile",
        component: load("ParentProfile"),
        meta: { requiredPermission: permissions.PARENT_PROFILE },
      },
      /*{
        path: "change-password",
        name: "changePassword",
        component: load("ChangePassword"),
      },*/
      {
        path: "regen-qrcode",
        name: "regenQrcode",
        component: load("RegenQrcode"),
        meta: { requiredPermission: permissions.LOGIN_QRCODE },
      },
      {
        path: "family",
        name: "familyProfile",
        component: load("FamilyProfile"),
      },
      {
        path: "mobile-verification",
        name: "mobileVerification",
        component: load("MobileVerification"),
      },
      /*{
        path: "associate",
        name: "accountAssociation",
        component: load("AccountAssociation"),
        meta: { requiredPermission: permissions.FULL_MEMBER_PROFILE },
      }, */
      {
        path: "login-info",
        name: "loginInformation",
        component: load("LoginInformation"),
      },
      {
        path: "*",
        redirect: { name: "basicProfile" },
      },
    ],
  },

  {
    path: "/:lang?/school-staff-info",
    name: "schoolStaffInfo",
    component: load("SchoolStaffInfo"),
    meta: { requiredPermission: permissions.TEACHER_PROFILE },
  },
  {
    path: "/:lang?/edb/register",
    name: "edbRegistration",
    component: load("EdbRegistration"),
  },
  {
    path: "/:lang?/users/register",
    name: "registration",
    component: load("Registration"),
  },
  {
    path: "/:lang?/login-emails/verify",
    name: "loginEmailVerification",
    component: load("LoginEmailVerification"),
  },
  {
    path: "/:lang?/contact-emails/verify",
    name: "contactEmailVerification",
    component: load("ContactEmailVerification"),
  },
  {
    path: "/:lang?/login-emails/mfa-verify",
    name: "mfaLoginEmailVerification",
    component: load("MfaLoginEmailVerification"),
  },
  {
    path: "/:lang?/teacher-auths/verify",
    name: "teacherAuthVerification",
    component: load("TeacherAuthVerification"),
  },
  {
    path: "/:lang?/subscriptions/verify",
    name: "emailSubscriptionVerification",
    component: load("EmailSubscriptionVerification"),
  },
  {
    path: "/:lang?/org_account",
    name: "organizationAccountList",
    component: load("OrganizationAccountList"),
    meta: {
      requiredPermission: permissions.READ_ORG_ACCOUNT,
      modifyPermission: permissions.WRITE_ORG_ACCOUNT,
    },
  },
  {
    path: "/:lang?/users/sso/google",
    name: "GoogleSSO",
    component: load("GoogleSSO"),
  },
  {
    path: "/:lang?/user-activate",
    name: "userActivation",
    component: load("UserActivation"),
  },
  {
    path: "/:lang?/user-activate-invalid",
    name: "userActivationInvalid",
    component: load("UserActivationInvalid"),
  },
  {
    path: "/:lang?/buyer-activate",
    name: "buyerAccountActivation",
    component: load("BuyerAccountActivation"),
  },
  {
    path: "/:lang?/buyer-activate-invalid",
    name: "buyerAccountActivationInvalid",
    component: load("BuyerAccountActivationInvalid"),
  },
  {
    path: "/:lang?/forget-password",
    name: "forgetPassword",
    component: load("ForgetPassword"),
  },
  {
    path: "/:lang?/reset-password",
    name: "resetPassword",
    component: load("ResetPassword"),
  },
  {
    path: "/:lang?/reset-password-invalid/:type?",
    name: "resetPasswordInvalid",
    component: load("ResetPasswordInvalid"),
  },
  {
    path: "/:lang?/email-subscriptions",
    name: "emailSubscriptions",
    component: load("EmailSubscriptions"),
  },
  {
    path: "/:lang?/mfa-login",
    name: "mfaLogin",
    component: load("MfaLogin"),
  },
  {
    path: "/:lang?/otp-login",
    name: "otpLogin",
    component: load("OtpLogin"),
  },
  {
    path: "/403",
    name: "forbidden",
    component: PageForbidden,
  },
  {
    path: "/404.html",
    name: "pageNotFound",
    component: PageNotFound,
  },
  {
    path: "*",
    redirect: { name: "pageNotFound" },
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const targetLang = to.params.lang;

  if (targetLang && targetLang === from.params.lang) {
    next();
    return;
  }

  if (!trans.supportedLanguages.includes(targetLang)) {
    next({
      name: to.name,
      params: { lang: trans.currentLanguage },
      query: to.query,
    });
  } else {
    trans.changeLanguage(targetLang);
    next();
  }
});

export default router;
